const applyColors = ({ primary, secondary }) => {
	const elements: HTMLCollectionOf<Element> = document.getElementsByClassName('cobraticket-widget');
	console.log('applyColors elements', elements);

	Array.prototype.forEach.call(elements, (element) => {
		element.style.setProperty('--user-primary', primary);
		element.style.setProperty('--user-secondary', secondary);
	});

	// Array.prototype.elements.forEach((element) => {
	//     element.style.setProperty('--primary-color', primary);
	//     element.style.setProperty('--secondary-color', secondary);
	// }
};

export { applyColors };
